import { zodResolver } from "@hookform/resolvers/zod";
import { forwardRef } from "react";

import { defaultHealthPersonalFormValues } from "@/D2C/features/health-quote/redux/health-quote/healthQuoteSlice";
import type { SharedPersonalAutofillValues } from "@/shared/stepper/PersonalDetailsFormStep";
import { PersonalDetailsFormStep } from "@/shared/stepper/PersonalDetailsFormStep";
import type { StepFormComponentProps, StepFormHandle } from "@/shared/stepper/types";
import { healthPersonalDetailsSchema } from "@/shared/validation/healthQuoteSchemas";
import { HealthPersonalFormValues } from "../../redux/type";

export const PersonalDetailsStep = forwardRef<
  StepFormHandle<HealthPersonalFormValues>,
  StepFormComponentProps<
    HealthPersonalFormValues,
    {
      autofillValues?: SharedPersonalAutofillValues;
      autofillVersion?: number;
      layoutClassName?: string;
      showAdditionalFields?: boolean;
      onValuesChange?: (values: HealthPersonalFormValues) => void;
      onDemoDataClick?: () => void;
      isReadOnly?: boolean;
    }
  >
>(function PersonalDetailsStep(
  {
    defaultValues,
    autofillValues,
    autofillVersion,
    layoutClassName,
    showAdditionalFields,
    onValuesChange,
    onDemoDataClick,
    isReadOnly,
  },
  ref
) {
  return (
    <PersonalDetailsFormStep
      ref={ref}
      defaultValues={defaultValues as any}
      resolver={zodResolver(healthPersonalDetailsSchema) as any}
      fallbackValues={defaultHealthPersonalFormValues as any}
      autofillValues={autofillValues}
      autofillVersion={autofillVersion}
      layoutClassName={layoutClassName}
      showAdditionalFields={showAdditionalFields}
      onValuesChange={onValuesChange as any}
      onDemoDataClick={onDemoDataClick}
      isReadOnly={isReadOnly}
    />
  );
});
